// JWT 凭证管理：localStorage 存 access token + username，给 api.ts 读、给登出按钮清。
//
// 之所以**也**把 username 缓存到 localStorage：登录页 → home 页之间 UI 要立刻显示
// 用户名，不必等 /api/auth/me 回来再渲染。token 是权威，username 只是缓存。

const TOKEN_KEY = 'sb_access_token'
const USERNAME_KEY = 'sb_username'

export interface Session {
    accessToken: string
    username: string
}

export function getSession(): Session | null {
    const accessToken = localStorage.getItem(TOKEN_KEY)
    const username = localStorage.getItem(USERNAME_KEY)
    if (!accessToken || !username) return null
    return { accessToken, username }
}

export function setSession(s: Session): void {
    localStorage.setItem(TOKEN_KEY, s.accessToken)
    localStorage.setItem(USERNAME_KEY, s.username)
}

export function clearSession(): void {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USERNAME_KEY)
}
